export const GPT_IMAGE_25_SIZES = {
  "auto": {
    "1K": "auto",
    "2K": "auto",
    "4K": "auto"
  },
  "1:1": {
    "1K": "1024x1024",
    "2K": "2048x2048",
    "4K": "2880x2880"
  },
  "3:2": {
    "1K": "1536x1024",
    "2K": "2048x1360",
    "4K": "3520x2336"
  },
  "2:3": {
    "1K": "1024x1536",
    "2K": "1360x2048",
    "4K": "2336x3520"
  },
  "4:3": {
    "1K": "1024x768",
    "2K": "2048x1536",
    "4K": "3312x2480"
  },
  "3:4": {
    "1K": "768x1024",
    "2K": "1536x2048",
    "4K": "2480x3312"
  },
  "5:4": {
    "1K": "1280x1024",
    "2K": "2560x2048",
    "4K": "3216x2576"
  },
  "4:5": {
    "1K": "1024x1280",
    "2K": "2048x2560",
    "4K": "2576x3216"
  },
  "16:9": {
    "1K": "1536x864",
    "2K": "2048x1152",
    "4K": "3840x2160"
  },
  "9:16": {
    "1K": "864x1536",
    "2K": "1152x2048",
    "4K": "2160x3840"
  },
  "2:1": {
    "1K": "2048x1024",
    "2K": "2688x1344",
    "4K": "3840x1920"
  },
  "1:2": {
    "1K": "1024x2048",
    "2K": "1344x2688",
    "4K": "1920x3840"
  },
  "21:9": {
    "1K": "2016x864",
    "2K": "2688x1152",
    "4K": "3840x1648"
  },
  "9:21": {
    "1K": "864x2016",
    "2K": "1152x2688",
    "4K": "1648x3840"
  },
  "3:1": {
    "1K": "1536x512",
    "2K": "3072x1024",
    "4K": "3840x1280"
  },
  "1:3": {
    "1K": "512x1536",
    "2K": "1024x3072",
    "4K": "1280x3840"
  }
};

export const GPT_IMAGE_25_EXT_RATIOS = ["auto", "1:1", "16:9", "9:16", "4:3", "3:4", "3:2", "2:3", "5:4", "4:5", "21:9"];
export const GPT_IMAGE_25_QUALITIES = ['low', 'medium', 'high', 'xhigh', 'max'];

// Default Flare/Sunburst prices shared by billing, estimates and pricing tables.
export const GPT_IMAGE_25_DEFAULT_CREDITS = { '1k': 4, '2k': 12, '4k': 16 };

// Standard prices apply globally to both new and existing users.
export const GPT_IMAGE_25_VIP_STANDARD_CREDITS = {
  '1K': { low: 4, medium: 8, high: 16, xhigh: 28, max: 64 },
  '2K': { low: 8, medium: 16, high: 32, xhigh: 56, max: 128 },
  '4K': { low: 12, medium: 28, high: 56, xhigh: 96, max: 216 },
};
export const GPT_IMAGE_25_VIP_DISCOUNT_PERCENT = 0;
export const GPT_IMAGE_25_VIP_INPUT_IMAGE_RATE = 0.5;
export const GPT_IMAGE_25_VIP_PRICE_TIERS = Object.fromEntries(
  Object.entries(GPT_IMAGE_25_VIP_STANDARD_CREDITS).map(([resolution, prices]) => [
    resolution,
    GPT_IMAGE_25_QUALITIES.map(quality => {
      const discountPercent = GPT_IMAGE_25_VIP_DISCOUNT_PERCENT;
      const standardCredits = prices[quality];
      return { quality, standardCredits, credits: standardCredits * (1 - discountPercent / 100), discountPercent };
    }),
  ])
);
// Shared by the server charge, generator estimate and pricing table usage counts.
export const GPT_IMAGE_25_VIP_CREDITS = Object.fromEntries(
  Object.entries(GPT_IMAGE_25_VIP_PRICE_TIERS).map(([resolution, tiers]) => [
    resolution, Object.fromEntries(tiers.map(({ quality, credits }) => [quality, credits])),
  ])
);
